import { MenuListProps } from '@chakra-ui/react'

// Common look of the actions menus (button-triggered and anchored)
export const menuListProps: MenuListProps = {
  fontFamily: 'body',
  fontSize: '1rem',
  fontWeight: 'normal',
  shadow: 'lg',
  zIndex: 2000,
}
